module.exports = __webpack_public_path__ + "static/media/slideMobile3.8bb5a1e4.jpg";